import { render, staticRenderFns } from "./MarketSentiment.vue?vue&type=template&id=b05c637a&scoped=true"
import script from "./MarketSentiment.vue?vue&type=script&lang=js"
export * from "./MarketSentiment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05c637a",
  null
  
)

export default component.exports